import firebase from "datastore/database";
import store from "datastore/store";

export async function getUserCountForPermissions(businessUid, permissionUid) {
  const querySnapshot = await firebase
    .firestore()
    .collection("users")
    .where("businessUids", "array-contains", businessUid)
    .get();

  let count = 0;
  querySnapshot.forEach((doc) => {
    const data = doc.data();

    if (data.branches && Array.isArray(data.branches)) {
      const hasMatchingBranch = data.branches.some(
        (branch) =>
          branch.businessUid === businessUid && branch.role === permissionUid
      );
      if (hasMatchingBranch) {
        count++;
      }
    }
  });
  return count;
}

function propertyExists(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

function getFilteredPermissions(permissions, businessUid, businessTier) {
  if (!permissions || !permissions.length) return [];
  const commonPermissions = permissions.filter(
    (permission) =>
      !propertyExists(permission, "businessUid") &&
      permission.tier === businessTier
  );

  const specificPermissions = permissions.filter(
    (permission) =>
      propertyExists(permission, "businessUid") &&
      permission.businessUid === businessUid
  );

  return [...commonPermissions, ...specificPermissions];
}

export default function observePermissions(
  groupBuid,
  businessUid,
  businessTier
) {
  store.dispatch({ type: "ADD_PERMISSIONS_LOADING" });
  return firebase
    .firestore()
    .collection(`access-controls/business-groups/${groupBuid}`)
    .onSnapshot(
      async (snap) => {
        try {
          const permissions = Object.create(null);
          let permissionsArr = snap.docs.map((doc) => ({
            uid: doc.id,
            ...doc.data(),
          }));

          permissionsArr = getFilteredPermissions(
            permissionsArr,
            businessUid,
            businessTier
          );

          const promises = permissionsArr.map((item) =>
            getUserCountForPermissions(businessUid, item.uid)
          );
          const results = await Promise.all(promises);
          for (let i = 0; i < permissionsArr.length; i++) {
            const item = permissionsArr[i];
            permissions[item.uid] = { ...item, userCount: results[i] };
          }
          store.dispatch({
            type: "ADD_PERMISSIONS_SUCCESS",
            permissions,
          });
        } catch (error) {
          store.dispatch({ type: "ADD_PERMISSIONS_ERROR", error });
        }
      },
      (error) => {
        store.dispatch({ type: "ADD_PERMISSIONS_ERROR", error });
      }
    );
}
